// extracted by mini-css-extract-plugin
export default {"back":"Paginate_back__nszJe","btn":"Paginate_btn__Z6Q9I","list":"Paginate_list__BHX-9"};